import React, { useState } from 'react';
import styles from './MonitoringNotifications.module.scss';
import { BellFilled, CloseOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Menu, notification } from 'antd';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import { deleteNotification, resetNotification } from '../../../../redux/actions/notifications';

const MonitoringNotifications = () => {
    const notifications = useSelector(state => state.notifications.notificationsList);
    const [isVisible, setIsVisible] = useState(false);

    const dispatch = useDispatch();

    const clearNotifications = () => {
        dispatch(resetNotification());

        notifications.forEach(notificationItem => {
            notification.close(notificationItem.id);
        });
    };

    const handleDeleteNotification = id => {
        dispatch(deleteNotification(id));
        notification.close(id);
    };

    const freezeOverlay = (
        <Menu className={styles.container}>
            <div className={styles.title}>
                <span className={styles.titleSpan}>Notifications</span>
                {notifications.length ? <Button onClick={clearNotifications}>Clear All</Button> : null}
            </div>

            {notifications.length > 0 ? (
                notifications.map(notification => (
                    <Menu.Item key={notification.id} className={styles.menuItem}>
                        <div className={styles.content}>
                            <span>{notification.content}</span>

                            <CloseOutlined
                                className={styles.delete}
                                onClick={() => handleDeleteNotification(notification.id)}
                            />
                        </div>
                        <span className={styles.time}>
                            {moment(notification.timestamp).format('DD MMM YYYY, HH:mm:ss')}
                        </span>
                    </Menu.Item>
                ))
            ) : (
                <div className={styles.noNotifications}>
                    <span>You currently have no notifications</span>
                </div>
            )}
        </Menu>
    );

    return (
        <Dropdown
            overlay={freezeOverlay}
            placement='bottomLeft'
            visible={isVisible}
            onVisibleChange={visible => {
                setIsVisible(visible);
            }}
        >
            <div className={styles.notificationsBox}>
                <Avatar
                    icon={<BellFilled onClick={() => setIsVisible(true)} className={styles.icon} />}
                    className={styles.avatar}
                />
                {notifications.length ? <div className={styles.notificationsCount}>{notifications.length}</div> : null}
            </div>
        </Dropdown>
    );
};

export default MonitoringNotifications;
